angular.module('unica_partner.partner_controllers')

.controller('PartnerEditController', function(
	$rootScope, $scope, $state, $stateParams,
	PartnerEditService
) {

	$scope.pageTitle = 'Modifica Partner';

	$rootScope.getPartner( $stateParams.id );

	$scope.savePartner = function() {
		$scope.showLoader();

		if ( typeof $rootScope.partnerData.avatar !== "undefined" ) {
			$rootScope.partnerData.avatar = $rootScope.partnerData.avatar.dataURL;
		} else {
			$rootScope.partnerData.avatar = '';
		}

		var partnerData = angular.copy($rootScope.partnerData);

		PartnerEditService
			.update(partnerData)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {

					data.avatar = {
						dataURL: data.avatar,
						resized: {
							dataURL: data.thumb
						}
					};

					$rootScope.partnerData = data;

					$scope.showSuccessMsg('Partner aggiornato con successo!', '');
					//$state.go('app.event.list', { year: $rootScope.year });
				} else {
					$rootScope.manageError(data);
				}
			});

	};

})

;